import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';
import type { MettreAJourUtilisateurData, UserAdminDTO } from '../dto/dtos';

export interface MettreAJourUtilisateurInput {
  idUtilisateur: string;
  data: MettreAJourUtilisateurData;
}

export class MettreAJourUtilisateurUseCase implements IUseCase<MettreAJourUtilisateurInput, UserAdminDTO> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: MettreAJourUtilisateurInput): Promise<UserAdminDTO> {
    const response = await this.repository.mettreAJourUtilisateur(input.idUtilisateur, input.data);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors de la modification');
    }

    return response.data!;
  }
}
